module.exports = __webpack_public_path__ + "images/emoji/bride_with_veil.3e411c5c5f59378578a9.png";